import { render, staticRenderFns } from "./AddDispatchConfig.vue?vue&type=template&id=ca55930a&"
import script from "./AddDispatchConfig.vue?vue&type=script&lang=js&"
export * from "./AddDispatchConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports